// import personaAvatar from "../../../assets/img/persona_avatar.jpg";
import { capitalizeWord } from "../../utils/string";

const PersonaSelectOption = ({ innerRef, innerProps, isFocused, isSelected, data }) => {
    return (
        <div
            ref={innerRef}
            {...innerProps}
            className={`cursor-pointer ${isFocused ? "bg-[#393939]" : ""} ${isSelected ? "bg-[#1e1e1e]" : ""} py-2 px-4 grid grid-cols-[35px_auto] gap-x-[10px] items-start`}
        >
            <div>
                <img
                    src={data.profile_photo || "/assets/img/persona_avatar.jpg"}
                    className="h-[35px] w-[35px] rounded-full object-cover"
                    alt="personaimage"
                />
            </div>
            <div>
                <h4 className="text-[14px] mb-0 font-medium">{data.label}</h4>
                <p className="mt-[-2px] select-description-overflow text-[13px] text-zinc-400">
                    {capitalizeWord(data.type)}
                </p>
            </div>
        </div>
    );
};

export default PersonaSelectOption;
